import { API_HOST } from "../constants";
import type {
  CategoryStatsResponse,
  ClustersResponse,
  Granularity,
  Market,
  MetaResponse,
  Period,
  TechStatsResponse,
  TechTrendResponse,
  TrendResponse,
} from "../types/jobMarket";

const BASE = `${API_HOST}/api/job-market`;

async function get<T>(path: string): Promise<T> {
  const res = await fetch(`${BASE}${path}`);
  if (!res.ok) throw new Error(`API error ${res.status}: ${path}`);
  return res.json();
}

export function fetchMeta(): Promise<MetaResponse> {
  return get("/meta");
}

export function fetchTechStats(
  period: Period,
  topN: number,
  compare: boolean,
  market: Market
): Promise<TechStatsResponse> {
  return get(
    `/tech-stats?period=${period}&top_n=${topN}&compare=${compare}&market=${market}`
  );
}

export function fetchCategoryStats(
  period: Period,
  compare: boolean,
  market: Market
): Promise<CategoryStatsResponse> {
  return get(`/category-stats?period=${period}&compare=${compare}&market=${market}`);
}

export function fetchTechTrend(
  topN: number,
  granularity: Granularity,
  market: Market
): Promise<TechTrendResponse> {
  return get(`/tech-trend?top_n=${topN}&granularity=${granularity}&market=${market}`);
}

export function fetchClusters(market: Market): Promise<ClustersResponse> {
  return get(`/clusters?market=${market}`);
}
